import page from 'page'
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Overlay from './Overlay'
import { Helmet } from 'react-helmet'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import * as _ from 'recompose'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { fetchingState, sendMindbox } from '../helpers/hocs.js'
import Loader from './Loader'
import InnerHTML from 'script-inner-html'

import { pay, widgetPay } from '../store/reducers/CP'

import { getIsLogged, getLoggedUser, getSettingsInfo } from '../selectors/user.js'

const HelpForm = ({ success = null, fetching, LoggedUser, SettingsInfo, submit, setInput, setCard, payments = [], checkout, tmpData,
  intl, notRequired = {}, hide = {}, setSuccess, errors, setErrors, inputCheck, checked, setChecked }) => {

  let self = this
  //let checked = ''
  console.log('LoggedUser', LoggedUser)
  if (LoggedUser) {
    LoggedUser.payments.map(data => {
      if (data.data.service === "cloudpayments") {
        payments.push(data.data)
      }
    })
  }



  function changeSum(sum) {
    if (checked && checked != 'other') {
      document.getElementById(checked).className = "mfc-modal__btn-radio-s"
    } else if (checked) {
      document.getElementById(checked).className = "mfc-modal__btn-radio-m"
    }
    if (sum && sum != 'other') {
      //document.getElementById('errorSum').innerHTML = '';
      //if (document.form.sum) document.form.sum.value = sum
      document.getElementById('sum').className = "mfc-modal__input-none"
      //var testElement = document.getElementsByClassName('mfc-modal__btn-radio-s-checked')[0]
      //if (testElement) testElement.className = "mfc-modal__btn-radio-s"
      document.getElementById(sum.toString()).className = "mfc-modal__btn-radio-s-checked-donation"
      setChecked(sum.toString())
    } else {
      document.getElementById('sum').className = "mfc-modal__input"//отображение инпута
      document.getElementById(sum).className = "mfc-modal__btn-radio-m-checked"//подсветка кнопки другая сумма
      setChecked(sum)
      document.getElementById('sum').value = document.getElementById('sum').value.replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  }

  function changeCard(data) {
    //document.form.card.value = data;
    var testElement = document.getElementsByClassName("PaymentCard PaymentCard_selected")[0]
    if (testElement) testElement.className = "PaymentCard"
    document.getElementById(data.toString()).className = "PaymentCard PaymentCard_selected"

    document.getElementById('errorCard').innerHTML = '';
  }

  function setSuccessFunc() {
    setSuccess(false)
  }

  return (
    <div className='Donate'>
      <Overlay isActive={success} onClose={setSuccessFunc}>
        <div className='Contacts-form__title Head mfc-modal__title'>
          <FormattedMessage id='help.donation_notice' />
        </div>
      </Overlay>
      <div style = {{
        
      }}
        className = 'mfc-donate__form'
      >
        <div style={{
          zIndex: 100,
          display: 'grid',
          color: 'black',
          alignSelf: 'center'
        }}>
          {<div className="mfc-modal__input-wrapper fontSize30px" style={{ zIndex: 100 }}>
            <label htmlFor="name">Имя {notRequired.name && "(опционально)"}</label>
            <input
              className='mfc-modal__input-donation'
              type="text"
              name="name"
              //onChange={validateName}
              onInput={SettingsInfo ? null : setInput('name')}
              value={SettingsInfo ? SettingsInfo.name : undefined}
              id="name"
              //style={{borderColor: 'black'}}
              style={{width: '360px'}}
              placeholder={intl.formatMessage({ id: 'help.whom' })}

            />
          </div>}
          {!hide.phone && <div className="mfc-help__input-wrapper fontSize30px" style={{ zIndex: 100 }}>
            <label htmlFor="phone">Телефон</label>
            <input
              className='mfc-modal__input-donation'
              type="text"
              name="phone"
              //onChange={validatePhone}
              onInput={SettingsInfo ? null : setInput('phone')}
              value={SettingsInfo && SettingsInfo.phone ? SettingsInfo.phone : undefined}
              id="phone"
              style={{width: '360px'}}
              //style={{borderColor: 'black'}}
              placeholder="7XXXXXXXXXX"
            />
          </div>}
          <div className="mfc-modal__input-wrapper fontSize30px" style={{ zIndex: 100 }}>
            <label htmlFor="sum">Сумма пожертвования</label>
            {<input
              className='mfc-modal__input-none'
              type="text"
              name="sum"
              id="sum"
              min="10"
              value={tmpData.sum}
              //onChange={validateSum}
              onInput={setInput('sum')}
              style={{borderColor: 'black'}}
              required
            />}
            <div className='mfc-modal__btn-group'>
              <div className='mfc-modal__btn-radio-group'>
                <a className='mfc-modal__btn-radio-s' style={{borderColor: 'black', color: 'black'}} id="3000" onClick={() => changeSum(3000)}><span onClick={setInput('3000')}>3 000 ₽</span></a>
                <a className='mfc-modal__btn-radio-s' style={{borderColor: 'black', color: 'black'}} id="10000" onClick={() => changeSum(10000)}><span onClick={setInput('10000')}>10 000 ₽</span></a>
                <a className='mfc-modal__btn-radio-s' style={{borderColor: 'black', color: 'black'}} id="30000" onClick={() => changeSum(30000)}><span onClick={setInput('30000')}>30 000 ₽</span></a>
              </div>
              <div className='mfc-modal__btn-radio-group'>
                <a className='mfc-modal__btn-radio-m' style={{borderColor: 'black', color: 'black'}} id="other" onClick={() => changeSum('other')}>Другая сумма</a>
              </div>
            </div>
          </div>

          {(payments.length != 0) && <div>
            <input type="hidden" id="card" name="card" />
            <br /><label className="fontSize30px">Карта для оплаты</label>
            <div className='mfc-modal__input-wrapper' style={{ zIndex: 100 }}>
              <div className='PaymentCards'>{/*платежная карта - смена карты и плат системы */}
                {payments.map(data =>
                  (data.visual) && (
                    <div className='PaymentCards__item' key={data._id}>
                      <div onClick={setCard(data._id)}>
                        <div className='PaymentCard' id={data._id} onClick={() => changeCard(data._id)}>
                          {(data.visual) && (<div className='PaymentCard__header'></div>)}
                          {(data.visual) && <div className='PaymentCard__number'>•••• •••• •••• {data.visual.card}</div>}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>}


          <div className="mfc-modal__checkbox-wrapper" style={{ zIndex: 100 }}>
            <div className="checkbox">
              <input className="custom-checkbox" type="checkbox" id="color-1" name="agreement" onChange={inputCheck(this)/*validateCheck*/}
              />
              <label htmlFor="color-1">Согласен с условиями&nbsp;
                <a href="/help/offer" target="_blank" className="mfc-modal__link">
                  публичной оферты
                </a>
              </label>
            </div>
            <span id='errorName' className='error'>{errors.name}</span>
            <span id='errorPhone' className='error'>{errors.phone}</span>
            <span id='errorSum' className='error'>{errors.sum}</span>
            <span id='errorCheck' className='error'>{errors.agreement}</span>
            <span id='errorCard' className='error'></span>
          </div>

          <div className="mfc-modal__btn-wrap" style={{ zIndex: 100 }}>
            <dev className='Button Button_black Main__members-button' style={{background: '#ff5027'}} /*onClick={cloudPay}*/>
              <span onClick={submit}><FormattedMessage id='help.help' /></span>
            </dev>
          </div>
          {/*<a className='mfc-modal__btn-submit' onClick={cloudPay} ><span onClick={submit}>123</span></a>*/}

        </div>
        <div style={{height: '100%'}}><img src="assets/img/cybersport.png" style={{width: '100%', alignSelf: 'flex-end'}}/></div>
      </div>


      {(fetching.send || fetching.info) && <Loader isLight />}
      {!isNil(success) && <div className='Text'> {} </div>}
      {(
        checkout ?
          <div className='Container Container_top-negative'>
            <div className='Main Main_privacy'>
              <InnerHTML html={checkout.exec} />
            </div>
          </div>
          :
          <div></div>
      )}


    </div>
  )
}

const mapStateToProps = state => {
  return ({
    currentLocale: state.intl.locale,
    isLogged: getIsLogged(state),
    LoggedUser: getLoggedUser(state),
    SettingsInfo: getSettingsInfo(state),
    ...state.CP
  })
}
const mapDispatchToProps = dispatch => bindActionCreators({ pay, widgetPay }, dispatch)
const mergeProps = (state, { pay, widgetPay }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  pay: (part) => fetchingWrap(pay.bind(this, part)),
  widgetPay: (part) => fetchingWrap(widgetPay.bind(this, part)),
})



export default injectIntl(compose(
  fetchingState(),//
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withState('tmpData', 'setTmpData', { name: undefined, phone: undefined, sum: undefined, agreement: undefined, userPaymentId: undefined, donationValue: undefined }),
  withState('errors', 'setErrors', {}),
  withState('success', 'setSuccess', false),
  withState('checked', 'setChecked', undefined),
  fetchingState({ multi: true }),
  withHandlers({
    checkName: ({ errors, setErrors, notRequired }) => (name) => {
      if (!name && !notRequired.name) {
        errors['name'] = 'Необходимо указать имя'
      }
      else {
        errors['name'] = ''
      }
      setErrors(errors)
      return errors['name']
    },
    checkPhone: ({ errors, setErrors, notRequired }) => (phone) => {
      if (!phone && !notRequired.phone) {
        errors['phone'] = 'Необходимо указать номер телефона'
      } else if (phone) {
        var re = /^\d[\d\(\)\ -]{9,9}\d$/;
        var valid = re.test(phone);
        if (!valid) {
          errors['phone'] = 'Номер телефона введен некорректно!'
        } else {
          errors['phone'] = ''
        }
      }
      setErrors(errors)
      return errors['phone']
    },
    checkSum: ({ errors, setErrors }) => (sum) => {
      sum = sum ? sum.replace(/\s/g, '') : null
      if ((!sum || sum < 10) || isNaN(sum)) {
        errors['sum'] = 'Минимальная сумма для пожертвования - 10 рублей';
      } else {
        errors['sum'] = '';
      }
      setErrors(errors)
      return errors['sum']
    },
    checkAgreement: ({ errors, setErrors }) => (agreement) => {
      if (!agreement) {
        errors['agreement'] = 'Необходимо согласие с условиями публичной оферты';
        //fullErrors = true;
      } else {
        errors['agreement'] = '';
      }
      setErrors(errors)
      return errors['agreement']
    }
  }),
  withHandlers({
    inputCheck: ({ setTmpData, tmpData, checkAgreement }) => field => e => {
      tmpData["agreement"] = e.target.checked
      setTmpData(tmpData)
      checkAgreement(tmpData["agreement"])
    },
    setInput: ({ setTmpData, tmpData, errors, setErrors, checkName, checkPhone, checkSum }) => field => e => {//запись данных при записи в input

      if (field === "sum") {
        //field = "donationValue"
        //sum - строка для визуального отображения с разрядами
        tmpData["sum"] = e.target.value.replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        //donationValue - число
        tmpData["donationValue"] = e.target.value.replace(/\s/g, '')
        checkSum(tmpData["donationValue"])
        console.log('tmpData[field]sum', tmpData[field])
        //checkSum(tmpData[field])
      }
      else if (field === "name" || field === "phone" || field === "email") {
        tmpData[field] = e.target.value
        if (field === "name") checkName(tmpData[field])
        if (field === "phone") checkPhone(tmpData[field])
      }
      else {
        tmpData["sum"] = field.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        tmpData["donationValue"] = field
        console.log('tmpData[field]["donationValue"]', tmpData["donationValue"])
        checkSum(tmpData["donationValue"])
      }
      setTmpData(tmpData)
    },
    setCard: ({ setTmpData, tmpData }) => field => value => {//запись данных при записи в input
      tmpData["userPaymentId"] = field
      setTmpData(tmpData)
    },
    setInputStat: ({ setTmpData, tmpData }) => field => value => {//запись данных при записи в input
      tmpData[field] = value
      setTmpData(tmpData)
    },
    submit: ({ success, tmpData, pay, setSuccess, widgetPay, noLoader = true, fetchingWrap, payments, setSuccess2, notRequired = {}, hide = {}, setErrors, errors, LoggedUser }) => async e => {
      console.log('e', e)
      e && e.preventDefault()

      let fullErrors = false;

      if (!tmpData.name && !notRequired.name) {
        errors['name'] = 'Необходимо указать имя'
        fullErrors = true;
      }
      else {
        errors['name'] = ''
      }

      if (!tmpData.phone && !notRequired.phone) {
        errors['phone'] = 'Необходимо указать номер телефона'
        fullErrors = true;
      } else if (tmpData.phone) {
        var re = /^\d[\d\(\)\ -]{9,9}\d$/;
        var valid = re.test(tmpData.phone);
        if (!valid) {
          errors['phone'] = 'Номер телефона введен некорректно!'
          fullErrors = true;
        } else {
          errors['phone'] = ''
        }
      }


      var sum = tmpData.donationValue ? tmpData.donationValue.replace(/\s/g, '') : null
      if ((!tmpData.donationValue || tmpData.donationValue < 10) || isNaN(tmpData.donationValue)) {
        errors['sum'] = 'Минимальная сумма для пожертвования - 10 рублей';
        fullErrors = true;
      } else {
        errors['sum'] = '';
      }

      if (!tmpData.agreement) {
        errors['agreement'] = 'Необходимо согласие с условиями публичной оферты';
        fullErrors = true;
      } else {
        errors['agreement'] = '';
      }
      setErrors(errors)

      if (!fullErrors) {
        if (tmpData.userPaymentId) {
          console.log('tmpData.userPaymentId')
          const result = noLoader ? await pay(tmpData) : await fetchingWrap(pay.bind(this, tmpData))
          if (result === 200) {
            setSuccess(true)
            setTimeout(() => {
              setSuccess(false)
              /*const mindboxData = {
                "customer": {
                  "mobilePhone": tmpData.phone,   
                  "fullName": `${LoggedUser.surname} ${LoggedUser.name} ${LoggedUser.middlename}`,
                  "ids": {
                    "websiteID": LoggedUser._id
                  },
                },
                "order": {
                  "ids": {
                    "websiteID": "<Идентификатор заказа Идентификатор заказа на сайте>"
                  },
                  "lines": [
                    {
                      "basePricePerItem": tmpData.sum,
                      "quantity": 1,
                      "product": {
                        "ids": {
                          "website": tmpData.userPaymentId
                        }
                      },
                      "status": "Create"
                    },
                  ],
                },
                "executionDateTimeUtc": new Date()
              }*/

              /*const mindboxData = {
                "customer": {
                  "mobilePhone": tmpData.phone, 
                  "fullName": LoggedUser ? `${LoggedUser.surname} ${LoggedUser.name} ${LoggedUser.middlename}` : tmpData.name,
                     "ids": {
                    "websiteID": LoggedUser._id
                  },
                },
                "order": {
                  "ids": {
                    "websiteID": "<Идентификатор заказа Идентификатор заказа на сайте>"
                  },
                  "payments": [
                    {
                      "type": "Card",
                      "amount": tmpData.sum,
                    }
                  ],
                  "lines": [
                    {
                      "basePricePerItem": tmpData.sum,
                      "quantity": 1,
                      "status": "Поддержка проекта"
                    }
                  ],
                },
                "executionDateTimeUtc": new Date()
              }

              sendMindbox(mindboxData, 'donation')*/
              //window.location.reload();
              //var win = window.open('/aboutus', '_self')
              //win.focus()
            }, 3000)
          }
        }
        else {
          if (!payments || payments.length == 0) {
            const result = noLoader ? await widgetPay(tmpData) : await fetchingWrap(widgetPay.bind(this, tmpData))
            if (result === 200) {
            }
          }
        }
      }
    }
  }),
  lifecycle({
    async componentWillMount() {
      if (this.props.SettingsInfo) {
        this.props.setInputStat('name')(this.props.SettingsInfo.name)
        this.props.setInputStat('phone')(this.props.SettingsInfo.phone)
        this.props.setInputStat('email')(this.props.SettingsInfo.email)
        this.props.setInputStat('userId')(this.props.LoggedUser._id)
        //this.props.setSuccess(null)
      }
    },
    componentDidMount() {
    },
    componentWillReceiveProps(np) {
      console.log('пропсы пожертвований*****************************', np)
    }
  }),
)(HelpForm))


// WEBPACK FOOTER //
// ./src/components/CybersportHelpForm.jsx